export type Lang = "ro" | "en";

const ro = {
    // Quote
    quote: "Dragostea nu este să te uiți unul la altul, ci să priviți împreună în aceeași direcție.",
    quoteAuthor: "— Antoine de Saint-Exupéry",

    // Welcome page
    enterCode: "Te rog să introduci codul de pe spatele invitației:",
    codePlaceholder: "Codul invitației",
    submit: "Gata!",
    errorBadCode: "Codul nu este bun",
    errorWrongCode: "Codul nu este valid",

    // Coming question
    gladYouCome: (name: string, plural: boolean) =>
        `Ne-am bucura, ${name}, dacă ${plural ? "ați putea" : "ai putea"} veni la cununia noastră.`,
    willBePresent: (plural: boolean) => plural ? "Vom fi prezenți" : "Voi fi prezent",
    cantCome: (plural: boolean) => plural ? "Din păcate, nu ajungem" : "Din păcate, nu ajung",
    rsvpDeadline: "Dorim să știm până în data de 10.05.2026.",

    // Details page
    happyYouCome: (name: string, plural: boolean) =>
        `Ne bucurăm foarte mult, ${name}, că ${plural ? "puteți veni" : "poți veni"}.`,
    optionalEventLabel: "Primărie",
    optionalEventDetails: "Primăria Satu Mare · 23 Mai · Ora 11:30",
    optionalEventNote: "(opțional, poate veni cine vrea)",
    optionalEventMapLink: "https://maps.app.goo.gl/5rQevUeedD3cCzYe6",
    eventDate: "23 Mai 2026",
    venueLabel: "Cununia Civilă",
    venueDetails: "Cabana Lac Apa · 23 Mai · Ora 13:30",
    venueMapLink: "https://maps.app.goo.gl/y5Q9QmqKMuVYUwL68",
    directions: "Direcții",
    addToCalendar: "Adaugă evenimentul în calendar:",
    numberOfPersons: "Număr de persoane (meniuri):",
    needHotel: "Este nevoie de cazare?",
    comingWithKids: (plural: boolean) => `O să ${plural ? "vi" : "veniți"} cu copii?`,
    numberOfKids: "Număr de copii:",
    numberOfKidsMenus: "Număr de meniuri de copii (jumătate din meniul normal):",
    vegetarianMenus: "Este nevoie de meniuri vegetariene?",
    numberOfVegetarianMenus: "Număr de meniuri vegetariene:",
    contactUs: "Pentru mai multe informații, ne puteți contacta la:",
    notComingQuestion: (plural: boolean) =>
        `În caz că nu mai ${plural ? "puteți veni" : "poți veni"}, vă rugăm să apăsați aici:`,
    saveSuccess: "Modificările au fost salvate cu succes.",
    saveError: "Ceva nu a mers bine. Te rog să dai refresh la pagină.",
    yes: "Da",
    no: "Nu",

    // Phone numbers
    alecs_ro: "0746412993",
    alecs_uk: "+44 7572115080",
    oana_ro: "0744187210",

    // Parents
    parent1: "Dan Vitoc",
    parent1_phone: "0745610085",
    parent2: "Liliana Vitoc",
    parent2_phone: "0746189267",
    parent3: "Radu Sabadâș",
    parent3_phone: "0740084333",
    parent4: "Simona Sabadâș",
    parent4_phone: "0740037669",

    // Godfathers
    godfathersLabel: "Nași:",
    godfather1: "Andrei Oros",
    godfather2: "Bianca Oros",

    // Refused page
    sorryNotComing: (plural: boolean) =>
        `Ne pare rău că nu ${plural ? "puteți veni" : "poți veni"}.`,
    changedMind: (plural: boolean) =>
        `În caz că ${plural ? "v-ați răzgândit" : "te-ai răzgândit"}, te rog să apeși pe butonul de mai jos:`,
    willCome: (plural: boolean) => plural ? "O să fim prezenți" : "O să fiu prezent",

    // Classic invite
    godBlessing: "Cu binecuvântarea Lui Dumnezeu,",
    alongsideParents: "Alături de părinții noștri,",
    inviteText: "Vă invităm să ne fiți alături la cununia noastră,",
    weddingDate: "23 Mai 2026",
    religiousCeremony: "Cununia Civilă",
    religiousVenue: "Primăria Satu Mare",
    religiousTime: "23 Mai · Ora 11:30",
    reception: "Cununia Civilă",
    receptionVenue: "Lac Apa, Baia Mare",
    receptionTime: "23 Mai · Ora 13:30",
    weWaitForYou: "Vă așteptăm cu drag!",
    confirmAttendance: "Apasă aici pentru a confirma/infirma prezența",
    pleaseConfirm: "Vă rugăm să ne confirmați prezența până în data de 10.05.2026:",
};

const en = {
    // Quote
    quote: "Love is not looking at one another, but looking together in the same direction.",
    quoteAuthor: "— Antoine de Saint-Exupéry",

    // Welcome page
    enterCode: "Please enter the code from the back of your invitation:",
    codePlaceholder: "Invitation code",
    submit: "Go!",
    errorBadCode: "The code is incorrect",
    errorWrongCode: "The code is not valid",

    // Coming question
    gladYouCome: (name: string, plural: boolean) =>
        `We would love for you to join us at our wedding, ${name}.`,
    willBePresent: (plural: boolean) => plural ? "We will be there" : "I will be there",
    cantCome: (plural: boolean) => plural ? "Unfortunately, we can't make it" : "Unfortunately, I can't make it",
    rsvpDeadline: "Please let us know by 26.08.2026.",

    // Details page
    happyYouCome: (name: string, plural: boolean) =>
        `We are so happy you can make it, ${name}!`,
    optionalEventLabel: "Town Hall",
    optionalEventDetails: "Primăria Satu Mare · 23 May · 11:30",
    optionalEventNote: "(optional, anyone can attend if they wish)",
    optionalEventMapLink: "https://maps.app.goo.gl/5rQevUeedD3cCzYe6",
    eventDate: "23 May 2026",
    venueLabel: "Reception",
    venueDetails: "Cabana Lac Apa · 23 May · 13:30",
    venueMapLink: "https://maps.app.goo.gl/BqgPnkTpiBiBXf5h6",
    directions: "Directions",
    addToCalendar: "Add the event to your calendar:",
    numberOfPersons: "Number of people (meals):",
    needHotel: "Do you need accommodation?",
    comingWithKids: (plural: boolean) => "Will you be bringing kids?",
    numberOfKids: "Number of kids:",
    numberOfKidsMenus: "Number of kids meals (half a normal meal):",
    vegetarianMenus: "Do you need vegetarian meals?",
    numberOfVegetarianMenus: "Number of vegetarian meals:",
    contactUs: "For more information, you can reach us at:",
    notComingQuestion: (plural: boolean) =>
        `If you can no longer attend, please let us know:`,
    saveSuccess: "Your changes have been saved successfully.",
    saveError: "Something went wrong. Please refresh the page.",
    yes: "Yes",
    no: "No",

    // Phone numbers (with +40 prefix for Romanian numbers)
    alecs_ro: "+40 746412993",
    alecs_uk: "+44 7572115080",
    oana_ro: "+40 744187210",

    // Parents
    parent1: "Dan Vitoc",
    parent1_phone: "+40 745610085",
    parent2: "Liliana Vitoc",
    parent2_phone: "+40 746189267",
    parent3: "Radu Sabadâș",
    parent3_phone: "+40 740084333",
    parent4: "Simona Sabadâș",
    parent4_phone: "+40 740037669",

    // Godfathers
    godfathersLabel: "Godfathers:",
    godfather1: "Andrei Oros",
    godfather2: "Bianca Oros",

    // Refused page
    sorryNotComing: (plural: boolean) =>
        `We're sorry you can't make it.`,
    changedMind: (plural: boolean) =>
        `If you've changed your mind, please press the button below:`,
    willCome: (plural: boolean) => plural ? "We will be there" : "I will be there",

    // Classic invite
    godBlessing: "With God's blessing,",
    alongsideParents: "Together with our parents,",
    inviteText: "We invite you to join us in the celebration of our marriage,",
    weddingDate: "23 May 2026",
    religiousCeremony: "Town Hall",
    religiousVenue: "Primăria Satu Mare",
    religiousTime: "23 May · 11:30",
    reception: "Reception",
    receptionVenue: "Cabana Lac Apa",
    receptionTime: "23 May · 13:30",
    weWaitForYou: "We look forward to celebrating with you!",
    confirmAttendance: "Click here to confirm or decline your attendance",
    pleaseConfirm: "Please confirm your attendance by 26.08.2026:",
};

export const translations = { ro, en };
